import { findColorants,createColorant,deleteColorant,updateColorant } from '../../_services/colorant.service.js';
import { getCompany } from '../../_utils/storage_handler.js';

export const findColorantsEvent = async () => {
    let res = await findColorants(getCompany());
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}
export const deleteColorantEvent = async (colorant) => {
    const body={
        colorant
    }
    let res = await deleteColorant(body);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const updateColorantEvent = async (colorant) => {
    const body={
        colorant
    }
    let res = await updateColorant(body);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const createColorantEvent = async (cod_colorant , name) => {
    const body={
        cod_colorant,
        name,
        company: getCompany()
    }
    let res = await createColorant(body);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}